import { useState } from "react";
import { fetchPatientBills } from "../../utils/patients/fetchPatientsBills";
import { bookAppointment } from "../../utils/patients/bookAppointment";
import { fetchVitals } from "../../utils/patients/fetchVitals";
import { fetchDrugs } from "../../utils/patients/dashboard/fetchDrugs";
import { fetchDrugMart } from "../../utils/patients/dashboard/fetchDrugMart";
import { sendRequest } from "../../utils/patients/sendRequest";
import { prescribeFill } from "../../utils/patients/prescribeFill";
import { generateBulkPaymentUrl } from "../../utils/patients/generateBulkPaymentUrl";
import {
  fetchPatientAddresses,
  savePatientAddress,
  deletePatientAddress,
  setDefaultPatientAddress,
} from "../../utils/patients/addressServices";
import useProfileStore from "../../store/patient/profileStore";
import { useAuth } from "../../context/AuthContext";
import { queryDrugs } from "../../utils/patients/queryDrugs";

const useManageDrugs = () => {

  const [loading, setLoading] = useState(false);
  const [drugs, setDrugs ] = useState({ result: [] });
  const [drugMart, setDrugMart] = useState({ result: [] })
  const [addresses, setAddresses] = useState([]);
  const {profile} = useProfileStore()

  const {user} = useAuth()

  // console.log(user,"user")
  

  // id = 27503
  const handleFetchDrugs = async () => {
    setLoading(true);
    await fetchDrugs(user?.id||profile?.id)
    .then((res) => {
        setLoading(false);
        // console.log(res?.data,"res---===============resdrugs")
        setDrugs(res?.data)
      })
      .catch((err) => {
        setLoading(false);
      });
  };


  const handleQuerytMart= async (data, prof) => {
    setLoading(true);
    await queryDrugs(data, prof)
    .then((res) => {
        setLoading(false);
        // setRequests(res?.data?.result)
        setDrugMart(res?.data)
      })
      .catch((err) => {
        setLoading(false);
      });
  };


  // id = 19957
  const handleFetchDrugMart = async () => {
    setLoading(true);
    try{
      const response = await fetchDrugMart()
      
      setDrugMart(response.data);
      console.log(response.data);
      
    } catch(err) {
      console.log(err)
      setLoading(false)
    } finally {
      setLoading(false)
    }
  };


    // id = 19957
    const handleSubmitRequest = async (id,request_type, payload, note) => {
      setLoading(true);
      try{
         const response = await sendRequest(id,request_type, payload, note)
         return response
      } catch(err) {
        window.location.href = "/pages/signin2";
        console.log("error error");
        console.log(err)
      } finally {
        setLoading(false)
      }
    };

    const handlePrescribeFill = async (patientId, items, note, delivery = {}) => {
      setLoading(true);
      try {
        const response = await prescribeFill({
          patient_id: patientId,
          items,
          request_note: note,
          delivery_method: delivery.delivery_method || "pickup",
          delivery_address: delivery.delivery_address || null,
          delivery_phone: delivery.delivery_phone || null,
          delivery_recipient: delivery.delivery_recipient || null,
          delivery_note: delivery.delivery_note || null,
          ...(delivery.delivery_address_id
            ? { delivery_address_id: delivery.delivery_address_id }
            : {}),
          ...(delivery.delivery_zone_id
            ? { delivery_zone_id: delivery.delivery_zone_id }
            : {}),
        });
        return response;
      } catch (err) {
        console.log(err);
        throw err;
      } finally {
        setLoading(false);
      }
    };

    const handleFetchAddresses = async () => {
      try {
        const response = await fetchPatientAddresses(user?.id || profile?.id);
        const data = response?.data?.data || [];
        setAddresses(data);
        return data;
      } catch (err) {
        console.log(err);
        return [];
      }
    };

    const handleSaveAddress = async (data) => {
      try {
        const response = await savePatientAddress(user?.id || profile?.id, data);
        if (response?.data?.success && response?.data?.data) {
          setAddresses((prev) => [response.data.data, ...prev]);
        }
        return response?.data;
      } catch (err) {
        console.log(err);
        return { success: false, message: err?.message };
      }
    };

    const handleDeleteAddress = async (addressId) => {
      try {
        const response = await deletePatientAddress(addressId);
        if (response?.data?.success) {
          setAddresses((prev) => prev.filter((a) => a.id !== addressId));
        }
        return response?.data;
      } catch (err) {
        console.log(err);
        return { success: false, message: err?.message };
      }
    };

    const handleSetDefaultAddress = async (addressId) => {
      try {
        const response = await setDefaultPatientAddress(addressId);
        if (response?.data?.success) {
          setAddresses((prev) =>
            prev.map((a) => ({ ...a, is_default: a.id === addressId }))
          );
        }
        return response?.data;
      } catch (err) {
        console.log(err);
        return { success: false, message: err?.message };
      }
    };

    const handleBulkPayment = async (transactionIds, patientId) => {
      setLoading(true);
      try {
        const response = await generateBulkPaymentUrl(transactionIds, patientId);
        return response;
      } catch (err) {
        console.log(err);
        throw err;
      } finally {
        setLoading(false);
      }
    };






  return {
    handleFetchDrugMart,
    handleFetchDrugs,
    handleQuerytMart,
    handleSubmitRequest,
    handlePrescribeFill,
    handleBulkPayment,
    handleFetchAddresses,
    handleSaveAddress,
    handleDeleteAddress,
    handleSetDefaultAddress,
    addresses,
    drugMart,
    drugs,
    loading,
  };
};

export default useManageDrugs;
